<div class="generated-url-container">
  <h3>{{ 'view_translations.generated_url' | translate }}</h3>

  <div class="text-input-container">
    <div class="input-wrapper">
      <input type="text" readonly value="{{ generatedURL }}" #partnerProgramLink />
    </div>
    <div>
      <div class="copy-button" (click)="copyInputMessage(partnerProgramLink)">
        <nb-icon class="copy-icon" icon="copy" pack="icomoon"></nb-icon>
      </div>
    </div>
  </div>
</div>
